import {NotificationTypeType} from '@/config/EventTriggerConfig'
import {NotificationTypeEnum} from '@/types/NotificationTypeEnum'

export const isSendPushStep = (notificationType?: NotificationTypeType) => {
  return notificationType?.type === NotificationTypeEnum.sendPush
}

export const isSendSmsStep = (notificationType?: NotificationTypeType) => {
  return notificationType?.type === NotificationTypeEnum.sendSMS
}

export const isSendWhatsAppStep = (notificationType?: NotificationTypeType) => {
  return notificationType?.type === NotificationTypeEnum.sendWhatsApp
}

export const isSendEmailStep = (notificationType?: NotificationTypeType) => {
  return notificationType?.type === NotificationTypeEnum.sendEmail
}
